import React from 'react';

const SEOFallback = () => {
  return (
    <div className="seo-fallback-content" style={{ display: 'none' }}>
      <h1>GenAI4Health2025 - The Second Workshop on GenAI for Health: Potential, Trust, and Policy Compliance</h1>
      
      <section>
        <h2>About GenAI4Health2025 Workshop</h2>
        <p>The Second Workshop on GenAI for Health: Potential, Trust, and Policy Compliance (GenAI4Health2025) will be held at NeurIPS 2025 in San Diego, California. This workshop brings together leading researchers and practitioners to explore the potential, trust, and policy compliance of Generative AI in healthcare.</p>
      </section>

      <section>
        <h2>GenAI4Health2025 Workshop Details</h2>
        <ul>
          <li><strong>Event:</strong> GenAI4Health2025 - The Second Workshop on GenAI for Health</li>
          <li><strong>Date:</strong> December 6-7, 2025</li>
          <li><strong>Location:</strong> San Diego Convention Center, San Diego, California</li>
          <li><strong>Conference:</strong> NeurIPS 2025</li>
          <li><strong>Paper Submission Deadline:</strong> September 5, 2025</li>
        </ul>
      </section>

      <section>
        <h2>GenAI4Health2025 Workshop Topics</h2>
        <p>The GenAI4Health2025 workshop will cover:</p>
        <ul>
          <li>Generative AI applications in healthcare</li>
          <li>AI trust and reliability in medical settings</li>
          <li>Policy compliance and regulatory frameworks</li>
          <li>Clinical AI implementation strategies</li>
          <li>AI safety in healthcare environments</li>
        </ul>
      </section>

      <section>
        <h2>GenAI4Health2025 Important Information</h2>
        <p>Join us at GenAI4Health2025 to explore the future of AI in healthcare. Submit your research papers by September 5, 2025, and be part of this groundbreaking workshop at NeurIPS 2025.</p>
      </section>

      <section>
        <h2>GenAI4Health2025 Contact Information</h2>
        <p>For more information about GenAI4Health2025 workshop, visit our submission portal or contact the workshop organizers.</p>
      </section>
    </div>
  );
};

export default SEOFallback; 